import React, { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";

import RejectRequestModal from "../components/RejectRequestModal";
import AcceptTransactionModal from "../components/AcceptTransactionModal";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import { useTheme } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import TablePagination from "@mui/material/TablePagination";

import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import LastPageIcon from "@mui/icons-material/LastPage";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import PropTypes from "prop-types";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export default function TransactionRequests() {
  const [listOfMintRequests, setListOfMintRequests] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const fetchMintData = async () => {
    var config = {
      method: "get",
      url: process.env.REACT_APP_MINTS_URL,
      headers: {
        "X-Api-Key": process.env.REACT_APP_X_API_KEY,
        "Access-Control-Allow-Origin": "*",
      },
    };
    try {
      const response = await axios(config);
      setListOfMintRequests(response.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchBurnData = async () => {
    var config = {
      method: "get",
      url: process.env.REACT_APP_BURNS_URL,
      headers: {
        "X-Api-Key": process.env.REACT_APP_X_API_KEY,
        "Access-Control-Allow-Origin": "*",
      },
    };
    try {
      const response = await axios(config);
      setListOfMintRequests((listOfMintRequests) => [
        ...listOfMintRequests,
        ...response.data,
      ]);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchMintData().then(() => {
      fetchBurnData();
    });
  }, []);

  return (
    <div className="transaction-requests">
      <Navbar />
      <Sidebar />
      <div className=" h-10 bg-white mx-24 text-gray-500 flex rounded justify-start pl-2 align-middle mt-4">
        <h1 style={{ fontSize: 25 }}>Transaction Requests</h1>
      </div>
      <div className="h-12 bg-white mx-24 flex text-gray-500 rounded justify-start pl-2 align-middle mt-4">
        <p className="description-paragraph">
          As one of the Communitas Principals you can accept or reject a request
          for depositing and withdrawing coins (mint and burn) from/to the
          users' wallet personal accounts. Those requests can be seen and
          managed equally by an other Communitas Principal in the same manner.
        </p>
      </div>

      <div className="flex flex-col bg-white mt-4 mx-24 rounded">
        <h3 className="font-bold text-3xl text-gray-500 pl-2">
          Deposit/Withdraw (Mint/Burn) Requests
        </h3>

        <hr className="container-hr" />

        <div className="table">
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
            colSpan={3}
            count={listOfMintRequests.length}
            rowsPerPage={rowsPerPage}
            page={page}
            sx={{ float: "right" }}
            SelectProps={{
              inputProps: {
                "aria-label": "rows per page",
              },
              native: true,
            }}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            ActionsComponent={TablePaginationActions}
          />

          <TableContainer component={Paper} sx={{ height: "800px" }}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell
                    align="center"
                    sx={{
                      maxWidth: 100,
                      backgroundColor: "#989898",
                      fontSize: 22,
                      color: "white",
                    }}
                  >
                    Request ID
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      maxWidth: 100,
                      backgroundColor: "#989898",
                      fontSize: 22,
                      color: "white",
                    }}
                  >
                    Account ID
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      backgroundColor: "#989898",
                      fontSize: 22,
                      color: "white",
                    }}
                  >
                    Request Type{" "}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      backgroundColor: "#989898",
                      fontSize: 22,
                      color: "white",
                    }}
                  >
                    Amount{" "}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      backgroundColor: "#989898",
                      fontSize: 22,
                      color: "white",
                    }}
                  >
                    Requested At
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      backgroundColor: "#989898",
                      fontSize: 22,
                      color: "white",
                    }}
                  >
                    Actions
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      backgroundColor: "#989898",
                      fontSize: 22,
                      color: "white",
                    }}
                  ></TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {(rowsPerPage > 0
                  ? listOfMintRequests
                      .sort(function (a, b) {
                        return a.assocComData < b.assocComData ? 1 : -1;
                      })
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                  : listOfMintRequests.sort(function (a, b) {
                      return a.assocComData < b.assocComData ? 1 : -1;
                    })
                ).map((req) => {
                  return (
                    <TableRow
                      key={req.ID}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell
                        scope="row"
                        sx={{
                          maxWidth: 200,
                          maxHeight: 10,
                          wordBreak: "break-all",
                        }}
                      >
                        {req.ID}
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{ maxWidth: 200, wordBreak: "break-all" }}
                      >
                        {req.accountID}
                      </TableCell>
                      {req.ID.includes("mint") ? (
                        <TableCell align="center">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "normal",
                              marginLeft: 21,
                            }}
                          >
                            <ArrowDownwardIcon
                              sx={{
                                marginRight: 1,

                                color: "#3cafa4",
                              }}
                            />
                            <h3>Deposit</h3>
                          </div>
                        </TableCell>
                      ) : (
                        <TableCell align="center" className="req-type">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "normal",
                              marginLeft: 21,
                            }}
                          >
                            <ArrowUpwardIcon
                              sx={{
                                marginRight: 1,

                                color: "#f05a25",
                              }}
                            />
                            <h3>Withdraw</h3>
                          </div>
                        </TableCell>
                      )}
                      <TableCell align="center">{req.amount}</TableCell>
                      <TableCell align="center">
                        {moment(req.assocComData).format("DD-MM-YYYY HH:mm:ss")}
                      </TableCell>
                      <TableCell align="center">
                        <div className="actions-buttons">
                          <RejectRequestModal req={req} />
                          <AcceptTransactionModal req={req} />
                        </div>
                      </TableCell>
                      <TableCell align="center"></TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
            colSpan={3}
            count={listOfMintRequests.length}
            rowsPerPage={rowsPerPage}
            page={page}
            sx={{ float: "right" }}
            SelectProps={{
              inputProps: {
                "aria-label": "rows per page",
              },
              native: true,
            }}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            ActionsComponent={TablePaginationActions}
          />
        </div>
      </div>
    </div>
  );
}
